import React, {
  useState, Fragment, useEffect,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CountryCodes } from '@Apis/constants';
import {
  Table, Select, Popconfirm, Button, Popover, Checkbox, Drawer, notification,
} from 'antd';
import PropTypes from 'prop-types';
import {
  DeleteOutlined, PlusCircleFilled, CheckOutlined, LoadingOutlined,
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { v4 as uuidv4 } from 'uuid';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';

const CounterVendorOfferForm = ({
  user, MONEY, addCounterNegotiationLoading, selectedParticipant, selectedRfq, callback, negotiationAction,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(selectedParticipant?.negotiation_lines?.map((negotiationLine) => ({ ...negotiationLine, key: uuidv4() })));
  }, []);

  const getColumns = () => {
    const columns = [
      {
        title: 'PRODUCT',
        render: (record) => {
          const rfqLines = selectedRfq?.rfq_lines;
          const productData = rfqLines?.find((rfqLine) => rfqLine?.rfq_line_id === record?.rfq_line_id);
          return (
            <Fragment>
              <Link to={`/inventory/product/view/${productData?.product_sku_info?.product_sku_id}`} target="_blank">
                {`#${productData?.product_sku_info?.internal_sku_code}`}
              </Link>
              <H3Text text={`${productData?.product_sku_info?.ref_product_code ? `${productData?.product_sku_info?.ref_product_code} - ` : ''}${productData?.product_sku_info?.product_sku_name}`?.trim()} className="" />
            </Fragment>
          );
        },
      },
      {
        title: 'VENDOR OFFER',
        width: '100px',
        render: (record) => (<div style={{ width: '100px' }}>{MONEY(record?.price)}</div>),
      },
      {
        title: 'COUNTER OFFER',
        width: '100px',
        render: (record) => (
          <div style={{ width: '100px' }}>
            <H3FormInput
              value={record.counter_price}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) < record?.price) ? 'create-pr__input' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                const copyData = JSON.parse(JSON.stringify(data));
                copyData.map((item) => {
                  if (item.key === record.key) {
                    item.counter_price = e.target.value;
                  }
                  return data;
                });
                setData(copyData);
              }}
            />
          </div>
        ),
      },
    ];

    return columns;
  };

  const isDataValid = () => {
    let isValid = true;
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.counter_price) {
        isValid = false;
      }
    }
    return isValid;
  };

  const handleCounterOffer = () => {
    setFormSubmitted(true);
    if (isDataValid()) {
      const counterNegotiationLines = data?.map((item) => ({
        negotiation_line_id: item?.negotiation_line_id,
        counter_price: item?.counter_price,
        counter_quantity: item?.quantity,
        counter_delivery_date: item?.delivery_date,
      }));

      const payload = {
        negotiation_id: selectedParticipant?.negotiation_id,
        counter_negotiation_lines: counterNegotiationLines,
      };
      negotiationAction('addCounterNegotiation', payload, () => {
        callback();
      });
    } else {
      notification.open({
        type: 'error',
        duration: 4,
        message: 'Please provide counter prices of all the products',
        placement: 'top',
      });
    }
  };

  return (
    <Fragment>
      <div className="counter-offer-form__wrapper">

        <div className="counter-offer-form__header">{selectedParticipant?.seller_info?.seller_name}</div>

        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <Table
              bordered
              loading={addCounterNegotiationLoading}
              showHeader
              size="small"
              columns={getColumns()}
              dataSource={data || []}
              pagination={false}
            />
          </div>

          <div className="custom-drawer__footer">
            <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text="Counter Offer"
                onClick={() => handleCounterOffer()}
                isLoading={addCounterNegotiationLoading}
                disabled={addCounterNegotiationLoading}
                style={{
                  width: '160px',
                  borderRadius: '5px',
                  padding: '7px 0px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, RfqReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  addCounterNegotiationLoading: RfqReducers.addCounterNegotiationLoading,

});

const mapDispatchToProps = (dispatch) => ({
  negotiationAction: (actionType, payload, callback) => dispatch(RfqActions.negotiationAction(actionType, payload, callback)),
});

CounterVendorOfferForm.propTypes = {
  user: PropTypes.any,
  addCounterNegotiationLoading: PropTypes.bool,
  negotiationAction: PropTypes.func,
  selectedParticipant: PropTypes.any,
  selectedRfq: PropTypes.any,
  callback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CounterVendorOfferForm));
